import { RelatedProducts } from './related_products';

export default RelatedProducts;
